import api from "../../../api/api";
/* ======================
   CLIENT APIs
====================== */

/** CREATE CLIENT */
export const createClient = (payload: any) => {
  return api.post("/customer/v1/customer_create/", payload);
};

export const getClientList = (page: number, params: any) => {
  return api.get("/customer/v1/customer_create/", {
    params: {
      page,
      ...params,
    },
  });
};

export const getClientSegmentMaster = () =>
  api.get("/hr/v1/client-segment-master/");

/** GET CLIENT BY ID */
export const getClientById = (id: number) => {
  return api.get(`/customer/v1/customer_create/${id}/`);
};

/** UPDATE CLIENT */
export const updateClient = (id: number, payload: any) => {
  return api.put(`/customer/v1/customer_create/${id}/`, payload);
};

/* ======================
   CONTACT PERSON APIs
====================== */

/** CREATE CONTACT PERSON */
export const createContactPerson = (payload: any) => {
  return api.post("/customer/v1/create-contact-person/", payload);
};

/** GET CONTACTS BY CLIENT */
export const getClientContacts = (customerId: number) => {
  return api.get(
    `/customer/v1/create-contact-person/?customer_id=${customerId}`
  );
};

/** UPDATE CONTACT PERSON */
export const updateContactPerson = (
  contactId: number,
  payload: any
) => {
  return api.put(
    `/customer/v1/create-contact-person/${contactId}/`,
    payload
  );
};

/** Delete contact person (hard delete via API) */
export const deleteContactPerson = (contactId: number) => {
  return api.delete(`/customer/v1/create-contact-person/${contactId}/`);
};
